<template>
  <div @keypress.enter="handleSubmit('formLogin')" class="layout" id="Login">
    <Row align="middle" justify="center" type="flex">
      <Col :md="{span:8}" :xs="{span:24}" style=" padding: 10px;background: lavender">
        <Divider>Login</Divider>
        <Card shadow>
          <Form :model="formLogin" :rules="ruleLogin" ref="formLogin">
            <FormItem label="Username" prop="email">
              <Input clearable placeholder="Username" type="text" v-model="formLogin.email">
                <Icon slot="prepend" type="ios-person-outline"></Icon>
              </Input>
            </FormItem>
            <FormItem label="Password" prop="password">
              <Input clearable placeholder="Password" type="password" v-model="formLogin.password">
                <Icon slot="prepend" type="ios-lock-outline"></Icon>
              </Input>
            </FormItem>
            <FormItem >
              <Row>
                <Col span="4" offset="10">
                  <Button @click="handleSubmit('formLogin')"  type="primary" :loading="loading">Login</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  // import gql from 'graphql-tag'
  import { NetworkCommunicator, setHeader } from '../plugins/NetworkResourceHandler'
  import {Constants} from '../Constants/Constant'

  export default {
    // apollo: {
    //   company: gql`{
    //     company{
    //     name
    //     industry}
    //     }`
    // },
    name: 'Login',
    data () {
      return {
        Constants: Constants,
        formLogin: {
          email: '',
          password: ''
        },
        ruleLogin: {
          email: [{validator: this.validateEmailMobile, trigger: 'blur'}],
          password: [
            { required: true, message: 'Please fill in the password.', trigger: 'blur' },
            { type: 'string', min: 4, message: 'The password length cannot be less than 6 bits', trigger: 'blur' }
          ]
        },
        loading: false
      }
    },
    methods: {
      validateEmailMobile(rule, value, callback){
        if(!value){
          callback(new Error('Please fill in the user name'))
        }else if(isNaN(value) && !Constants.emailPattern.test(value)){          //string
          callback(new Error('Please enter valid email'))
        }else if(!isNaN(value) && value.length !== 10){                          //number
          callback(new Error('Please enter 10 digit Mobile number'))
        }else {
          callback()
        }
      },
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.doLogin()
          }
        })
      },
      async doLogin () {
        this.loading = true
        let request = {password: this.formLogin.password}
        request[isNaN(this.formLogin.email)?'email':'mobile'] = this.formLogin.email          //set key as per data
        let response = await NetworkCommunicator('POST',
          `${Constants.api_url}login`, false, request)
        if (response.flag) {
          localStorage.setItem('token', 'ac4fZ5om9QBRi4EP')
          localStorage.setItem('cities', JSON.stringify(response.data.city))
          localStorage.setItem('roleId', response.data.user.role)
          this.$store.commit('setUserObj', response.data)
          let accessibleUrls = [];
          response.data.menu.forEach((curnt) => {
            if(curnt.title) curnt.subMenu.forEach((sub) => accessibleUrls.push(sub.url))
          })
          this.$store.commit('setAccessibleUrls', accessibleUrls)
          setHeader()
          this.loading = false
          this.$router.replace({ path: (accessibleUrls.length)?accessibleUrls[0]:'/login'})
        } else {
          this.loading = false
          this.$Message.error('Invalid Credential')
        }
      }
    },
    beforeCreate () {
      // if (localStorage.getItem('token') != undefined && localStorage.getItem('token') != '') {
      //   this.$router.replace({ path: '/companies' })
      // }
    }
  }
</script>


<style lang="less" scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
